export const VENDOR_ROUTE = '/vendor/';
export const SHOPS_LIST_ROUTE = VENDOR_ROUTE + 'shops/';
export const SHOP_ROUTE = VENDOR_ROUTE + 'Shop/';
export const INSERTION_ROUTE = VENDOR_ROUTE + 'Insertion/';
export const ARTICLE_LIST_ROUTE = VENDOR_ROUTE + 'articles/';
export const ARTICLE_ROUTE = VENDOR_ROUTE + 'article/';
export const COUPON_REDEEM_ROUTE = VENDOR_ROUTE + 'couponRedeem/';
export const COUPON_LIST_ROUTE = VENDOR_ROUTE + 'couponList/';
export const DEFAULT_PREFIX = '';
export const ADVERTISEMENT_ROUTE = VENDOR_ROUTE +'advertisements'
export const SPONSORED_NOTIFICATIONS_ROUTE = VENDOR_ROUTE + 'sponsored-notifications/';
export const SPONSORED_NOTIFICATION_CREATE_ROUTE = VENDOR_ROUTE + 'sponsored-notification/';
export const WALLET_ROUTE = VENDOR_ROUTE + 'wallet/';
export const VISIBILITY_FILTERS = Object.freeze({ all: 0, visible: 1, hidden: 2 });

export const VENDOR_HOME_ROUTE = VENDOR_ROUTE + 'home/';
